
$(document).ready( function(){
	$('.button__show-hidden-rows').on('click', function(e){
		$(document).find($(this).attr('data-table')).find('.row--hidden').removeClass('row--hidden');
		$(this).attr('disabled','disabled');
	});
});



//////////////////
// WEBPACK FOOTER
// ./app/js/components/tables.js
// module id = 2
// module chunks = 0